import { ActivityType } from '../../entities';

const ActivityTypeTextMap: Record<ActivityType, string> = {
  [ActivityType.BuildFitillion]: 'Build (Strength)',
  [ActivityType.BurnFitillion]: 'Burn (Cardio)',
  [ActivityType.BalanceFitillion]: 'Balance (Pilates)',
  [ActivityType.BoxingFitillion]: 'Boxing',
  [ActivityType.PowerStationFitillion]: 'Power Station',
  [ActivityType.TreadmillFitillion]: 'Treadmill',
  [ActivityType.StudioBikeFitillion]: 'Studio Bike',
  [ActivityType.Stepper]: 'Stepper',
  [ActivityType.Running]: 'Running',
  [ActivityType.Climbing]: 'Climbing',
  [ActivityType.PilatesAndYoga]: 'Pilates & Yoga',
  [ActivityType.Elliptical]: 'Elliptical',
  [ActivityType.Cycling]: 'Cycling',
  [ActivityType.StrengthTraining]: 'Strength Training',
  [ActivityType.OtherCardio]: 'Other Cardio',
  [ActivityType.Swimming]: 'Swimming',
  [ActivityType.Multisport]: 'Multi Sport',
  [ActivityType.HIIT]: 'HIIT',
  [ActivityType.Gymnastics]: 'Gymnastics',
  [ActivityType.WinterSports]: 'Winter Sports',
  [ActivityType.WalkingAndHiking]: 'Walking & Hiking',
  [ActivityType.RacquetSport]: 'Racquet Sport',
  [ActivityType.RowingAndPaddling]: 'Rowing',
  [ActivityType.TeamSports]: 'Team Sports',
  [ActivityType.DanceAndAerobics]: 'Dance & Aerobics',
  [ActivityType.CombatAndMartialArts]: 'Combat',
};

export function getActivityTypeText(activityType: ActivityType): string {
  return ActivityTypeTextMap[activityType] ?? 'Other';
}
